import React, {ReactNode, useEffect, useState} from 'react';

import {LoginCallback, useOktaAuth} from '@okta/okta-react';
import {CALLBACK_PATH} from 'src/modules/authentication/okta-provider/typedefs';

import Loading from '@pb/kit-component-loading';

type Props = {
    children: ReactNode,
};

export const OktaAuthenticationController = ({children}: Props) => {
    const {oktaAuth, authState} = useOktaAuth();
    const [showContent, setShowContent] = useState(false);

    const isCurrentPathLoginCallback = () => {
        const currentPath = window.location.pathname;
        return currentPath === CALLBACK_PATH;
    };

    useEffect(() => {
        if (authState && !authState.isAuthenticated && !isCurrentPathLoginCallback()) {
            oktaAuth.signInWithRedirect();
        }
    }, [authState, oktaAuth]);

    useEffect(() => {
        if (authState?.isAuthenticated) {
            setShowContent(true);
        }
    }, [authState?.isAuthenticated]);

    return (
        <>
            <LoginCallback/>
            {showContent ? children : <Loading fast={true}/>}
        </>
    );
};
